import { render } from "./Thumbnails.vue?vue&type=template&id=ec96b9e0&scoped=true"
const script = {}

import "./Thumbnails.vue?vue&type=style&index=0&id=ec96b9e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec96b9e0"]])

export default __exports__